export default {
    /**
     * Init custom markup in order to style select element (required by `_m-select.scss`).
     */
    initSelect: function (selector = "select", selectClass = "m-select") {
        document
            .querySelectorAll(`${selector}:not([multiple]):not(.${selectClass}__select)`)
            .forEach((select) => {
            const wrapper = document.createElement("span");
            wrapper.classList.add(selectClass);
            select.classList.add(`${selectClass}__select`);
            select.replaceWith(wrapper);
            wrapper.appendChild(select);
        });
    },
};
